// extracted by mini-css-extract-plugin
export const container = "image-cut-module--container--1jn9B";
export const background = "image-cut-module--background--uWKDG";